export const formatDate = (dateString, format = "DD-MM-YYYY") => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formats = {
    "DD-MM-YYYY": `${day}-${month}-${year}`,
    "YYYY-MM-DD": `${year}-${month}-${day}`,
    "DD/MM/YYYY": `${day}/${month}/${year}`,
    "DD MMM YYYY": `${day} ${date.toLocaleString("default", { month: "short" })} ${year}`,
    "DD-MM-YYYY HH:mm": `${day}-${month}-${year} ${hours}:${minutes}`,
    "ISO": date.toISOString(),
  };

  return formats[format] || formats["DD-MM-YYYY"];
};


export const toEndOfDayISO = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).toISOString();

export const getToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};